import { gql } from '@apollo/client';

import { CreateMultipleChoiceExerciseInput, MultipleChoiceExercise } from '../../types';
import { multipleChoiceExerciseFragment } from '../fragments';

export interface CreateMultipleChoiceExerciseMutationVariables {
  courseId: string;
  subjectId: string;
  input: CreateMultipleChoiceExerciseInput;
}

export interface CreateMultipleChoiceExerciseMutationResult {
  multipleChoiceExercise: MultipleChoiceExercise;
}

export const createMultipleChoiceExerciseMutation = gql`
  mutation CreateMultipleChoiceExerciseMutation($courseId: String!, $subjectId: String!, $input: CreateMultipleChoiceExerciseMutationInput!) {
    multipleChoiceExercise(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises", method: "POST") {
      ...MultipleChoiceExercise
    }
  }
  ${multipleChoiceExerciseFragment}
`;
